import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../widgets/Modal';
import feedbackSuccess from '../../../assets/icons/Feedback/feedback-success.svg';
import Button from '../../widgets/Button';
import { useWidgetsModalContext } from '../../../shared/providers/WidgetsModalProvider';

interface FeedbackModalProps {
  open: boolean;
}

function SuccessModal({ open }: FeedbackModalProps) {
  const { setFeedbackSuccessOpen } = useWidgetsModalContext();
  const { t } = useTranslation();
  const closeModal = () => setFeedbackSuccessOpen(false);

  return (
    <Modal open={open} modalClassName="w-[400px]" handleClose={closeModal}>
      <div className="grid justify-center text-center">
        <img src={feedbackSuccess} className="m-auto mb-6" alt="" />
        <h3 className="pb-2 text-lg font-semibold">
          {t('FEEDBACK_SUCCESS_HEADING')}
        </h3>
        <p className="text-black-600 mb-[56px] text-sm">
          {t('FEEDBACK_SUCCESS_SUBHEADING')}
        </p>
        <Button size="lg" onClick={closeModal}>
          {t('FEEDBACK_SUCCESS_BUTTON')}
        </Button>
      </div>
    </Modal>
  );
}

export default SuccessModal;
